// extracted by mini-css-extract-plugin
module.exports = {"wrap_div":"Footer_wrap_div__1-huJ","lang_div":"Footer_lang_div__Az0hM"};